import { useI18n } from "@/context/I18nContext";
import { MultiFilter } from "@/components/MultiFilter";

export const RANGE_NAMES = { van: "Van chevaux", prosport: "Remorque fourgon", occasion: "Occasion" };
const regionNames = typeof Intl.DisplayNames === "function" ? new Intl.DisplayNames(["fr"], { type: "region" }) : null;
export const countryName = (c) => { try { return regionNames?.of(c) || c; } catch { return c; } };

export const GeoFilters = ({ items, country, setCountry, range, setRange, prefix }) => {
  const { t } = useI18n();
  const countries = [...new Set(items.map((i) => i.country).filter(Boolean))].sort();
  const ranges = [...new Set(items.flatMap((i) => i.ranges || []).filter((r) => RANGE_NAMES[r]))].sort();
  return (
    <>
      <MultiFilter label={t("Pays")} options={countries.map((c) => ({ value: c, label: `${countryName(c)} (${c})` }))} sel={country} onChange={setCountry} testid={`${prefix}-country-filter`} />
      <MultiFilter label={t("Gamme")} options={ranges.map((r) => ({ value: r, label: t(RANGE_NAMES[r]) }))} sel={range} onChange={setRange} testid={`${prefix}-range-filter`} className="w-52" />
    </>
  );
};
